require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils")) : factory(root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__5__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[32],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("react-dom");

/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = scrollableDnD;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _reactDom = _interopRequireDefault(__webpack_require__(11));

var _utils = __webpack_require__(5);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const SCROLL_DRAG_DISTANCE = 50;
const RESTET_HOVER_BUFFER = 75;
const SCROLL_BUFFER = 15;

function scrollableDnD(Comp) {
  class ScrollableDnD extends _react.Component {
    constructor(...args) {
      super(...args);
      (0, _defineProperty2.default)(this, "_distanceX", 0);
      (0, _defineProperty2.default)(this, "_distanceY", 0);
      (0, _defineProperty2.default)(this, "_handleMouseMove", () => {
        if (this._getPosition() && !this._raf) {
          this._raf = requestAnimationFrame(this._handleMouseOver);
          this._lastRAFTime = null;
        }
      });
      (0, _defineProperty2.default)(this, "_handleMouseOver", time => {
        const position = this._getPosition();

        const boundingRect = this._node.getBoundingClientRect();

        const rect = {
          top: boundingRect.top - SCROLL_BUFFER,
          bottom: boundingRect.bottom + SCROLL_BUFFER,
          left: boundingRect.left - SCROLL_BUFFER,
          right: boundingRect.right + SCROLL_BUFFER
        };

        if (!this._lastRAFTime) {
          this._lastRAFTime = time;
          requestAnimationFrame(this._handleMouseOver);
        } else if (position && _utils.domUtils.offsetWithinBoundingRect(position, rect)) {
          const dt = (time - this._lastRAFTime) / 100;
          this._lastRAFTime = time;
          const distanceBottom = rect.bottom - position.y;
          const distanceTop = position.y - rect.top;
          const distanceLeft = position.x - rect.left;
          const distanceRight = rect.right - position.x;
          let isScrollingBottom = distanceBottom > 0 && distanceBottom < SCROLL_DRAG_DISTANCE;
          let isScrollingTop = distanceTop > 0 && distanceTop < SCROLL_DRAG_DISTANCE;
          let isScrollingLeft = distanceLeft > 0 && distanceLeft < SCROLL_DRAG_DISTANCE;
          let isScrollingRight = distanceRight > 0 && distanceRight < SCROLL_DRAG_DISTANCE;

          if (isScrollingTop && isScrollingBottom) {
            isScrollingTop = distanceTop > distanceBottom;
            isScrollingBottom = !isScrollingTop;
          }

          if (isScrollingLeft && isScrollingRight) {
            isScrollingLeft = distanceLeft > distanceRight;
            isScrollingRight = !isScrollingLeft;
          }

          let distanceY = 0;

          if (isScrollingBottom) {
            distanceY = Math.max((SCROLL_DRAG_DISTANCE - distanceBottom) * dt, 1);
          } else if (isScrollingTop) {
            distanceY = -Math.max((SCROLL_DRAG_DISTANCE - distanceTop) * dt, 1);
          }

          this._node.scrollTop += distanceY;

          if (distanceY) {
            this._distanceY += Math.abs(distanceY);
          } else {
            this._distanceY = 0;
          }

          let distanceX = 0;

          if (isScrollingLeft) {
            distanceX = -Math.max((SCROLL_DRAG_DISTANCE - distanceLeft) * dt, 1);
          } else if (isScrollingRight) {
            distanceX = Math.max((SCROLL_DRAG_DISTANCE - distanceRight) * dt, 1);
          }

          this._node.scrollLeft += distanceX;

          if (distanceX) {
            this._distanceX += Math.abs(distanceX);
          } else {
            this._distanceX = 0;
          }

          if ((isScrollingTop || isScrollingBottom || isScrollingLeft || isScrollingRight) && (this._distanceX > RESTET_HOVER_BUFFER || this._distanceY > RESTET_HOVER_BUFFER)) {
            this._resetHover();
          }

          requestAnimationFrame(this._handleMouseOver);
        } else {
          this._distanceX = 0;
          this._distanceY = 0;
          cancelAnimationFrame(this._raf);
          this._raf = null;
        }
      });
      (0, _defineProperty2.default)(this, "_getPosition", () => this.context.dragDropManager.getMonitor().getClientOffset());
      (0, _defineProperty2.default)(this, "_resetHover", () => this.context.dragDropManager.getActions().hover([], {
        clientOffset: this._getPosition()
      }));
      (0, _defineProperty2.default)(this, "_ref", r => {
        const {
          scrollableDnDForwardRef
        } = this.props;
        this.wrappedComponent = r;
        this._node = _reactDom.default.findDOMNode(r);
        scrollableDnDForwardRef && scrollableDnDForwardRef(r);
      });
    }

    componentDidMount() {
      this._node.addEventListener('mousemove', this._handleMouseMove);
    }

    componentWillUnmount() {
      cancelAnimationFrame(this._raf);
    }

    render() {
      const {
        scrollableDnDForwardRef,
        // eslint-disable-line @typescript-eslint/no-unused-vars
        ...others
      } = this.props;
      return /*#__PURE__*/_react.default.createElement(Comp, (0, _extends2.default)({}, others, {
        ref: this._ref
      }));
    }

  }

  (0, _defineProperty2.default)(ScrollableDnD, "propTypes", {
    scrollableDnDForwardRef: _propTypes.default.any
  });
  (0, _defineProperty2.default)(ScrollableDnD, "contextTypes", {
    dragDropManager: _propTypes.default.object
  });
  return _react.default.forwardRef((props, ref) => /*#__PURE__*/_react.default.createElement(ScrollableDnD, (0, _extends2.default)({}, props, {
    scrollableDnDForwardRef: ref
  })));
}

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 23:
/***/ (function(module, exports) {

module.exports = require("react-dnd");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 355:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(356);


/***/ }),

/***/ 356:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

var _interopRequireWildcard = __webpack_require__(3);

exports.__esModule = true;

var _itemDnD = _interopRequireWildcard(__webpack_require__(357));

exports.default = _itemDnD.default;
exports.itemDnD = _itemDnD.default;
exports.ITEM_TYPE = _itemDnD.ITEM_TYPE;

var _scrollableDnD = _interopRequireDefault(__webpack_require__(174));

exports.scrollableDnD = _scrollableDnD.default;

/***/ }),

/***/ 357:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = _default;
exports.ITEM_TYPE = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _reactDom = _interopRequireDefault(__webpack_require__(11));

var _reactDnd = __webpack_require__(23);

var _utils = __webpack_require__(5);

var _scrollableDnD = _interopRequireDefault(__webpack_require__(174));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const {
  omit
} = _utils.lodash;
let lastHoveredYPercent;
let lastHoveredXPercent;

const idFn = x => x;

const ITEM_TYPE = 'ITEM_TYPE';
exports.ITEM_TYPE = ITEM_TYPE;

function _default(Comp, {
  dragItemType,
  dropItemType,
  simpleHoverStates = true,
  scrollable = false
}) {
  const getHoveredY = () => {
    if (simpleHoverStates) {
      return lastHoveredYPercent >= 50;
    }

    return lastHoveredYPercent;
  };

  const getHoveredX = () => {
    if (simpleHoverStates) {
      return lastHoveredXPercent >= 50;
    }

    return lastHoveredXPercent;
  };

  const dropTargetMethods = {
    canDrop(props, monitor) {
      if (props.canDrop) {
        return props.canDrop((props.getDropProps || idFn)(props, getHoveredY(), getHoveredX()), monitor.getItem(), monitor);
      }

      return false;
    },

    drop(props, monitor) {
      if (props.onDrop && !monitor.didDrop()) {
        props.onDrop((props.getDropProps || idFn)(props, getHoveredY(), getHoveredX()), monitor.getItem(), monitor);
      }
    },

    hover(props, monitor, component) {
      const hoverBoundingRect = (props.customDnDNode || _reactDom.default.findDOMNode(component)).getBoundingClientRect();

      const clientOffset = monitor.getClientOffset();
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      const hoverClientX = clientOffset.x - hoverBoundingRect.left;
      lastHoveredYPercent = hoverClientY / (hoverBoundingRect.bottom - hoverBoundingRect.top) * 100;
      lastHoveredXPercent = hoverClientX / (hoverBoundingRect.right - hoverBoundingRect.left) * 100;

      if (props.onHover) {
        props.onHover((props.getDropProps || idFn)(props, getHoveredY(), getHoveredX()), monitor.getItem(), monitor);
      }

      if (simpleHoverStates) {
        // forceUpdate in order to pass down updated hover states to child component
        component.forceUpdate();
      }
    }

  };
  const dragSourceMethods = {
    beginDrag(props) {
      const {
        onBeginDrag
      } = props;
      return (onBeginDrag || idFn)(props);
    },

    canDrag(props) {
      const {
        canDragNode
      } = props;
      return !canDragNode || canDragNode(props);
    },

    endDrag(props) {
      props.onEndDrag && props.onEndDrag(props);
    }

  };

  const addDropTarget = () => (0, _reactDnd.DropTarget)(dropItemType, dropTargetMethods, (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isActive: () => monitor.isOver() && monitor.canDrop()
  }));

  const addDragSource = () => (0, _reactDnd.DragSource)(dragItemType, dragSourceMethods, connect => ({
    connectDragSource: connect.dragSource()
  }));

  let WrappedComponent = Comp;

  if (scrollable) {
    WrappedComponent = (0, _scrollableDnD.default)(Comp);
  }

  class Item extends _react.Component {
    constructor(...args) {
      super(...args);
      (0, _defineProperty2.default)(this, "_resovleRef", ref => {
        const node = _reactDom.default.findDOMNode(ref);

        if (node && !this.props.customDnDNode) {
          this._connectToDnD(node);
        }

        const {
          itemDnDForwardRef
        } = this.props;
        itemDnDForwardRef && itemDnDForwardRef(ref);
      });
      (0, _defineProperty2.default)(this, "_connectToDnD", node => {
        const {
          connectDragSource,
          connectDropTarget
        } = this.props;
        connectDropTarget && connectDropTarget(node);
        connectDragSource && connectDragSource(node);
      });
    }

    componentDidMount() {
      const {
        customDnDNode
      } = this.props;

      if (customDnDNode) {
        this._connectToDnD(customDnDNode);
      }
    }

    componentWillReceiveProps(nextProps) {
      if (nextProps.customDnDNode && nextProps.customDnDNode !== this.props.customDnDNode) {
        this._connectToDnD(nextProps.customDnDNode);
      }
    }

    render() {
      const {
        isActive,
        dragLayerRenderer,
        // eslint-disable-line @typescript-eslint/no-unused-vars
        ...other
      } = this.props;
      const passThroughProps = { ...omit(other, 'canDrop', 'canDragNode', 'onBeginDrag', 'onEndDrag', 'connectDropTarget', 'connectDragSource', 'getDropProps', 'onHover', 'customDnDNode', 'itemDnDForwardRef')
      };
      const active = isActive && isActive();
      let hoverProps = {
        hoveredActive: active
      };

      if (active && simpleHoverStates) {
        const hoveredBelow = getHoveredY();
        const hoveredRight = getHoveredX();
        hoverProps = { ...hoverProps,
          hoveredRight,
          hoveredBelow,
          hoveredAbove: !hoveredBelow,
          hoveredLeft: !hoveredRight
        };
      }

      return /*#__PURE__*/_react.default.createElement(WrappedComponent, (0, _extends2.default)({}, hoverProps, passThroughProps, {
        ref: this._resovleRef
      }));
    }

  }

  (0, _defineProperty2.default)(Item, "propTypes", {
    customDnDNode: _propTypes.default.object,
    dragging: _propTypes.default.bool,
    itemRenderer: _propTypes.default.func,
    // NOTE: isRequired causing warning 'undefined' in console. Removed isRequired for now - can be added back if any side effects or new insights.
    connectDropTarget: _propTypes.default.func.isRequired,
    connectDragSource: _propTypes.default.func.isRequired,
    dragLayerRenderer: _propTypes.default.func,
    // NOTE: isRequired causing warning 'undefined' in console. Removed isRequired for now - can be added back if any side effects or new insights.
    isActive: _propTypes.default.func.isRequired,
    getDropProps: _propTypes.default.func.isRequired,
    onBeginDrag: _propTypes.default.func.isRequired,
    itemDnDForwardRef: _propTypes.default.any
  });
  let ItemDnD = Item;

  if (dragItemType) {
    ItemDnD = addDragSource()(ItemDnD);
  }

  if (dropItemType) {
    ItemDnD = addDropTarget()(ItemDnD);
  }

  if (ItemDnD === Item) {
    throw new Error("itemDnD: 'dragItemType' and/or 'dropItemType' must be provided");
  }

  return _react.default.forwardRef((props, ref) => /*#__PURE__*/_react.default.createElement(ItemDnD, (0, _extends2.default)({}, props, {
    itemDnDForwardRef: ref
  })));
}

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__5__;

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ })

},[[355,0]]]);
});